<template>
  <div class="main-component-pc-lector-articulo-elaborado-y-actividad">
    <div class="header">
      <div class="header-lefth">
        <span>
          {{ t('production.assignBoxesPallet.lastRead') }}
        </span> <span class="barCode">
          {{ currentBarCodeArticuloElaborado }}
        </span>
      </div>
    </div>

    <UCMultiInputSelector
      ref="multiInputSelectorRef"
      :conf="confUCMultiSelector"
      @validate-input="handleValidateInput"
    />
  </div>
</template>

<script setup>
// @ts-check
import UCMultiInputSelector from '@/components/common/UCMultiInputSelector.vue';
import icCode from '@/static/icons/ic_code.svg';
import { sleep } from '@/js/utils/sleep';
import { computed, ref, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';

/** @import { PropType, ShallowRef } from 'vue' */

const props = defineProps({
  // Permite que la cámara continúe abierta para hacer lecturas mientras no se pulsa el botón back.
  continuousBarCodeReading: {
    type: Boolean,
    default: false,
  },
  orientationScan: {
    type: /** @type {PropType<'portrait' | 'landscape'>} */ (String),
    default: 'portrait',
  },
  // Flash Camara
  torchOn: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits([
  'code-reading-articulo-elaborado',
]);

const { t } = useI18n();
const currentBarCodeArticuloElaborado = ref('');
/** @type {ShallowRef<InstanceType<typeof UCMultiInputSelector> | null>} */
const multiInputSelectorRef = shallowRef(null);

const confUCMultiSelector = computed(() => [
  /** @type {const} */ ({
    id: 'BOX',
    placeholder: t('production.common.boxReading'),
    iconButton: icCode,
    altButton: 'Icono lectura de cajas',
    showBarCodeButton: true,
    confReadBarCode: {
      fabButtonShow: false,
      autoOpenCamera: true,
      autofocusOnInput: false,
      continuousBarCodeReading: props.continuousBarCodeReading,
      orientationScan: props.orientationScan,
      torchOn: props.torchOn,
    },
  }),
]);

/**
 * @public
 * @returns {void}
 */
function reset() {
  currentBarCodeArticuloElaborado.value = '';
}

/**
 * @public
 * @returns {Promise<void>}
 */
async function focus() {
  await sleep(100);
  multiInputSelectorRef.value?.focus();
}

/**
 * @param {string} val
 * @returns {void}
 */
function handleValidateInput(val) {
  currentBarCodeArticuloElaborado.value = val;
  emit('code-reading-articulo-elaborado', val);
}

defineExpose({
  focus,
  reset,
});
</script>

<style lang="scss">
.main-component-pc-lector-articulo-elaborado-y-actividad {
  .header {
    display: flex;
    justify-content: space-between; // Esto coloca los elementos al inicio y al final
    color: #24253d;
    text-transform: none;
    font-size: 17px;
    padding-left: 25px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 12px;
    border-bottom: 4px;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-color: var(--his-disabled);
    border-style: solid;
    background: aliceblue;

    .header-lefth {
      padding-top: 3px;
      color: var(--his-steel-blue);
      font-size: 14px;
      font-weight: 400;

      .barCode {
        font-weight: 600;
      }
    }
  }
}
</style>
